import { Box, Checkbox, Typography } from '@mui/material';
import React, { useState } from 'react';
import { AutoSizer, List } from 'react-virtualized';
import 'react-virtualized/styles.css'; // Import default styles
import ModalHeader from '../../common/Header';
import MButton from '../../common/MButton';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { getGroupBoardingReportData } from '../../../redux/Report/ReportActions';
import { updateShowAlert } from '../../../redux/Actions';

const SelectServices = (props) => {
    const { userDetails } = useSelector((state) => state.common);
    const dispatch = useDispatch()
    const { filterOpt, handleBack, filterValue, setFilterValue, setCurrentScreen } = props;
    const [selectedServices, setSelectedServices] = useState(new Set());
    const handleCheckboxChange = (tripId) => {
        setSelectedServices((prevSelected) => {
            const newSelected = new Set(prevSelected);
            if (newSelected.has(tripId)) {
                newSelected.delete(tripId);
            } else {
                newSelected.add(tripId);
            }
            return newSelected;
        });
    };

    const rowRenderer = ({ index, key, style }) => {
        const trip = filterOpt?.serviceList[index];
        return (
            <Box key={key} style={style} className="trip-card">
                <Typography className="trip-name">{trip?.TripNameLong}</Typography>
                <Box className="trip-details">
                    <p className="trip-time">{trip?.TripTime}</p>
                    <Checkbox
                        color="primary"
                        size="small"
                        checked={selectedServices.has(trip?.TripID)}
                        onChange={() => handleCheckboxChange(trip?.TripID)}
                    />
                </Box>
            </Box>
        );
    };

    const handleProceedClick = () => {
        const tripIDs = selectedServices.size > 1 ? Array.from(selectedServices).join(",") : Array.from(selectedServices)[0] || 0;
        const body = {
            Date: dayjs(filterValue?.date).format("YYYY-MM-DD"),
            tripIDs: tripIDs,
            intCompanyID: userDetails?.CompanyID,
            fromCityID: filterValue?.city?.[0]?.FromCityID || 0,
            groupName: filterValue?.pickupGrp?.[0]?.GroupName === 'All Pickup Group' ? 'all-pickups' : filterValue?.pickupGrp?.[0]?.GroupName || '',
            pickupId: filterValue?.pickup?.[0]?.PickupId || 0,
            isJourneydateWise: filterValue?.isJourneyDate,
            intLoginUserID: userDetails?.UserID || 0,
        }
        dispatch(getGroupBoardingReportData(body)).then((res) => {
            if (res.data.MavenAPIGroupBoardingReportDataResult.IsSuccess) {
                const parsedData = JSON.parse(res.data.MavenAPIGroupBoardingReportDataResult.Data);
                setFilterValue((prev) => ({
                    ...prev,
                    serviceData: parsedData?.Table
                }))
                setCurrentScreen(4);
                //  setShowReport(true)
            } else {
                dispatch(updateShowAlert({
                    msg: res?.data?.MavenAPIGroupBoardingReportDataResult.ErrorMessage,
                    open: true,
                }));
            }

        })
    };

    return (
        <Box>
            <ModalHeader headerText="Select Services" showBackArrow={true} onBackClick={handleBack} />
            <Box className="trip-list" sx={{ width: '100%', height: 'calc(100vh - 40px)' }}>
                <AutoSizer>
                    {({ height, width }) => (
                        <List
                            width={width}
                            height={height}
                            rowCount={filterOpt?.serviceList?.length || 0}
                            rowHeight={100} // Adjust the height based on your design
                            rowRenderer={rowRenderer}
                        />
                    )}
                </AutoSizer>
            </Box>
            {selectedServices.size > 0 && (
                <Box className="bookingTypeBottom">
                    <MButton btnName="Proceed" className="btnContinue" onClick={handleProceedClick} />
                </Box>
            )}
        </Box>
    );
};

export default SelectServices;
